import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'textAnalysis',
  name: 'Text Analysis',
  category: 'ai-nodes',
  description: 'Analyze text for sentiment, keywords, language detection, and more',
  icon: 'FileText',
  color: 'blue',
  version: '1.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Text Analysis',
    color: '#3b82f6'
  },
  
  subtitle: '={{ $parameter.operation }}',
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['text', 'analysis', 'nlp', 'sentiment', 'language'],
  
  comingSoon: true
};

export default definition;
